import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Image, Popover } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { MdAdd, MdOutlineContentCopy, MdSearch } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { toast } from "react-toastify";
import deletepic from "../../assets/delete.svg";
import disablepic from "../../assets/Disable Icon.svg";
import forwardpic from "../../assets/forward.svg";
import MyVerticallyCenteredModal from "../../Components/DeleteModal/DeleteModal";
import Loader from "../../Components/Loader/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import { getVoucherDeleteModelFlag } from "../../redux/DeleteModelFlagSlice";
import { DeleteVoucherApi } from "../../Utils/Api/DeleteVoucherApi";
import { DisableVoucherCouponApi } from "../../Utils/Api/DisableVoucherCoupon";
import { ManageVouchersApi } from "../../Utils/Api/ManageVouchers";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import FacebookShare from "../../Components/SocialShare/FacebookShare";
import WhatsappShare from "../../Components/SocialShare/WhatsappShare";
import { FormatDateShortMonth } from "../../Utils/FormatDateShortMonth";

const ManageVouchers = () => {
  const [manageVouchersData, setManageVouchers] = useState([]);
  const [deleteId, setDeleteID] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [eligibleFlag, setEligibleFlag] = useState(false);
  const [search, setSearch] = useState("");
  const [flag, setFlag] = useState({
    voucherName: 0,
    expiryDate: 0,
    availableDate: 0,
    total: 0,
    sold: 0,
    redeemed: 0,
    active: 0,
  });

  // const shareUrl = process.env.REACT_APP_COMMON_URL + "my-account/view-voucher";

  const uid = parseInt(userId());

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const ManageVouchersAPIHandler = async (searchVal, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }

    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));
    const val = {
      business_id: uid,
      limit: 10,
      offset: searchVal ? 0 : pageNumber,
      search_value: searchVal,
      column_name: ColName ? ColName : colName,
      sort_type: SortVal ? SortVal : sortval,
    };
    if (!val.sort_type && !val.column_name) {
      setLoading(true);
    }
    const VoucherTableData = await ManageVouchersApi(val, () => {
      navigate("/");
    });
    console.log("VoucherTableData", VoucherTableData);
    if (VoucherTableData === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (VoucherTableData.status === 429) {
        setLoading(true);
        toast.error(VoucherTableData.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (!val.sort_type && !val.column_name) {
        setLoading(false);
      }
      // console.log(VoucherTableData);;
      setManageVouchers(VoucherTableData.data);
      setTotalPageCount(VoucherTableData.total_page_count);
      setEligibleFlag(VoucherTableData.create_voucher_eligible);
      setLimit(VoucherTableData.limit);
    }
  };

  const handleDelete = async (flag) => {
    if (flag === true) {
      const val = {
        business_id: uid,
        voucher_id: deleteId,
      };
      setLoading(true);
      const filteredList = await DeleteVoucherApi(val, () => {
        navigate("/");
      });
      if (filteredList === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (filteredList.success === true) {
          toast.success(filteredList.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          ManageVouchersAPIHandler();
          setLoading(false);
          setModalShow(false);
        } else if (filteredList.status === 429) {
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(true);
        } else {
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(false);
        }
      }
    }
  };

  const DisableHandler = async (flag) => {
    if (flag === true) {
      const val = {
        checkvoucher_coupon: "vouhcer",
        product_id: deleteId,
        business_id: uid,
      };
      setLoading(true);
      const DisabledRes = await DisableVoucherCouponApi(val, () => {
        navigate("/");
      });
      if (DisabledRes === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (DisabledRes.success === true) {
          toast.success(DisabledRes.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          ManageVouchersAPIHandler();
          setLoading(false);
          setModalShow(false);
        } else if (DisabledRes.status === 429) {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(true);
        } else {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;
    setSearch(val.trim());
    if (!val) {
      ManageVouchersAPIHandler("");
    }
  };

  const CreateVoucherHandler = (flag, id) => {
    if (eligibleFlag === true) {
      if (flag === "clone" && id !== null) {
        navigate(`/my-account/clone-voucher/${id.toString()}/true`);
      } else if (flag === "create") {
        navigate("/my-account/create-vouchers");
      }
    } else {
      toast.error(
        "Hey there, you have exceeded the voucher limit creation. Upgrade your subscription to create more vouchers. Kindly refer to My Profile - Subscription page.",
        {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    }
  };

  const handleSearchClick = () => {
    ManageVouchersAPIHandler(search);
  };

  // enter-keyboard
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      ManageVouchersAPIHandler(search);
    }
  };

  const HandleSortCouponName = () => {
    if (flag.voucherName === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_name");
      setFlag((ps) => {
        return { ...ps, voucherName: 1 };
      });
    } else if (flag.voucherName === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_name");
      setFlag((ps) => {
        return { ...ps, voucherName: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, voucherName: 0 };
      });
    }
  };

  const HandleSortAvailableDate = () => {
    if (flag.availableDate === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_avail_until_date");
      setFlag((ps) => {
        return { ...ps, availableDate: 1 };
      });
    } else if (flag.availableDate === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_avail_until_date");
      setFlag((ps) => {
        return { ...ps, availableDate: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, availableDate: 0 };
      });
    }
  };

  const HandleSortExpiryDate = () => {
    if (flag.expiryDate === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_end_date");
      setFlag((ps) => {
        return { ...ps, expiryDate: 1 };
      });
    } else if (flag.expiryDate === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_end_date");
      setFlag((ps) => {
        return { ...ps, expiryDate: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, expiryDate: 0 };
      });
    }
  };

  const HandleSortTotal = () => {
    if (flag.total === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_limit");
      setFlag((ps) => {
        return { ...ps, total: 1 };
      });
    } else if (flag.total === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_limit");
      setFlag((ps) => {
        return { ...ps, total: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, total: 0 };
      });
    }
  };

  const HandleSortSold = () => {
    if (flag.sold === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_download_count");
      setFlag((ps) => {
        return { ...ps, sold: 1 };
      });
    } else if (flag.sold === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_download_count");
      setFlag((ps) => {
        return { ...ps, sold: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, sold: 0 };
      });
    }
  };

  const HandleSortRedeemed = () => {
    if (flag.redeemed === 0) {
      ManageVouchersAPIHandler(search, 1, "voucher_redeem_count");
      setFlag((ps) => {
        return { ...ps, redeemed: 1 };
      });
    } else if (flag.redeemed === 1) {
      ManageVouchersAPIHandler(search, 2, "voucher_redeem_count");
      setFlag((ps) => {
        return { ...ps, redeemed: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, redeemed: 0 };
      });
    }
  };

  const HandleSortActive = () => {
    if (flag.active === 0) {
      ManageVouchersAPIHandler(search, 1, "active_count");
      setFlag((ps) => {
        return { ...ps, active: 1 };
      });
    } else if (flag.active === 1) {
      ManageVouchersAPIHandler(search, 2, "active_count");
      setFlag((ps) => {
        return { ...ps, active: 2 };
      });
    } else {
      ManageVouchersAPIHandler(search, 0, "voucher_id");
      setFlag((ps) => {
        return { ...ps, active: 0 };
      });
    }
  };

  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    ManageVouchersAPIHandler();
    window.scrollTo(0, 0);
  }, [pageNumber]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3 align-center">
        <p className="page-maintitle manage-title">Manage Vouchers</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={200}
                onChange={handleChange}
                onKeyPress={handleKeypress}
              />
            </InputGroup.Text>
            <Form.Control />
            <Button variant="outline-secondary" onClick={handleSearchClick}>
              Search
            </Button>
          </InputGroup>
          <Button
            variant="primary"
            className="create-btn create-voucher-button"
            onClick={() => CreateVoucherHandler("create", null)}
          >
            <MdAdd className="add-btn" /> Create Voucher
          </Button>
        </div>
      </div>
      <p className="info-text my-2">
        Each voucher sale has a transaction fees. The CommunityX Digital
        Platform charges 14% of the voucher value as transaction fees.
        Additional transaction fees may be charged by the marketplace you are
        participating. Review your total transaction fees in your “My Profile”
        tab in the “Marketplace Membership” regarding transaction fees.
      </p>
      <SearchBarResults SearchValue={search} />
      <div className="table-responsive-xl black-header">
        <div className="flex justify-end items-center gap-1">
          <MdOutlineContentCopy fill="#E66100" />
          <p>To copy/clone the voucher</p>
        </div>
        <table className="recentact-table mt-3 table ver-middle manage-vou-table man-vou-list-Table">
          <thead>
            <tr>
              {/* <th className="radio-colors"></th> */}
              <th width="300px">
                <Button onClick={HandleSortCouponName}>
                  Voucher Name
                  {flag.voucherName === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucherName === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={HandleSortAvailableDate}
                  style={{ margin: "auto" }}
                >
                  Available Until Date
                  {flag.availableDate === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.availableDate === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              {/* <th width="150px">
                Marketplace <Image loading="lazy" src={sortpic} className="sortimg"></Image>
              </th> */}
              <th>
                <Button
                  onClick={HandleSortExpiryDate}
                  style={{ margin: "auto" }}
                >
                  Expiry Date{" "}
                  {flag.expiryDate === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.expiryDate === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button onClick={HandleSortTotal} style={{ margin: "auto" }}>
                  Total{" "}
                  {flag.total === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.total === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button onClick={HandleSortSold} style={{ margin: "auto" }}>
                  Sold{" "}
                  {flag.sold === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.sold === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button onClick={HandleSortRedeemed} style={{ margin: "auto" }}>
                  Redeemed{" "}
                  {flag.redeemed === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button onClick={HandleSortActive} style={{ margin: "auto" }}>
                  Active{" "}
                  {flag.active === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.active === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th
                className="action-main text-white"
                style={{ textAlign: "center", color: "#fff!important" }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {manageVouchersData?.length > 0 ? (
              manageVouchersData.map((data) => {
                return (
                  <tr
                    key={data.id}
                    className={data.is_active === false ? "disable" : ""}
                  >
                    {/* {data.is_active === 1 ? (
                      <td className="radio-colors">
                        <Image loading="lazy" src={greenradio}></Image>
                      </td>
                    ) : (
                      <td className="radio-colors">
                        <Image loading="lazy" src={redradio}></Image>
                      </td>
                    )} */}
                    <td
                      className="text-left text-limit-2 blue-underline-text"
                      title={data.voucher_name}
                    >
                      <Link
                        to={`/my-account/view-voucher/${data.voucher_id.toString()}`}
                      >
                        {data.voucher_name}
                      </Link>
                    </td>
                    {/* <td>
                      <p className="text-limit-2" title={data.marketplace}>
                        {data.marketplace}
                      </p>
                    </td> */}
                    <td className="date-col" style={{ textAlign: "center" }}>
                      {FormatDateShortMonth(data.voucher_avail_until_date)}
                    </td>

                    <td className="date-col" style={{ textAlign: "center" }}>
                      {FormatDateShortMonth(data.end_date)}
                    </td>

                    <td style={{ textAlign: "center" }}>{data.total}</td>

                    <td style={{ textAlign: "center" }}>
                      {data.purchase_count}
                    </td>

                    <td style={{ textAlign: "center" }}>{data.redeem_count}</td>

                    <td style={{ textAlign: "center" }}>
                      {data.active_vouchers}
                    </td>
                    <td>
                      <div className="action-img table-man-vou action-div">
                        {data.is_active === false ? (
                          <>
                            {/* <Image loading="lazy" src={editpic}></Image> */}
                            <Image loading="lazy" src={deletepic}></Image>
                            <Image
                              loading="lazy"
                              src={forwardpic}
                              title="Share"
                            ></Image>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => {
                                setModalShow(true);
                                setDeleteID(data.voucher_id);
                                dispatch(
                                  getVoucherDeleteModelFlag(data.purchased)
                                );
                              }}
                              title="Delete"
                            >
                              <Image
                                loading="lazy"
                                src={
                                  data.purchased === true
                                    ? disablepic
                                    : deletepic
                                }
                              ></Image>
                            </button>
                            <OverlayTrigger
                              // show={true}
                              trigger="click"
                              placement="top"
                              rootClose
                              overlay={
                                <Popover
                                  id="popover-positioned-top"
                                  title="Share to:"
                                >
                                  <FacebookShare
                                    shareUrl={data.product_share_url}
                                  />
                                  <WhatsappShare
                                    shareUrl={data.product_share_url}
                                  />
                                </Popover>
                              }
                            >
                              <Image
                                loading="lazy"
                                src={forwardpic}
                                style={{ cursor: "pointer" }}
                                title="Share"
                              ></Image>
                            </OverlayTrigger>
                          </>
                        )}
                        <MdOutlineContentCopy
                          fill="#E66100"
                          title="Clone"
                          onClick={() =>
                            CreateVoucherHandler("clone", data.voucher_id)
                          }
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div>
        {totalPageCount > 10 ? (
          <Pagination
            TotalPageCount={totalPageCount}
            Limit={limit}
            SetPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>

      <MyVerticallyCenteredModal
        handleDeletefuc={handleDelete}
        handleDisablefuc={DisableHandler}
        show={modalShow}
        onHide={() => setModalShow(false)}
        page={"voucher"}
      />
    </>
  );
};

export default ManageVouchers;
